import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'

export interface ClashCardStyleProps {
    isResolved?: boolean
}

/**
 * Styles for ClashCard component
 * Provides card styling, resolved state styling, and action icon styling
 */
export const useClashCardStyles = makeStyles<Theme, ClashCardStyleProps>((theme) => ({
    card: {
        marginBottom: theme.spacing(2),
        transition: 'all 0.3s ease',
        border: `1px solid ${theme.palette.divider}`,
        width: '100%',
        boxSizing: 'border-box',
        borderRadius: 3,
        borderLeft: '3px solid #D85A79',
    },
    resolvedCard: {
        backgroundColor: theme.palette.grey[100],
        opacity: 0.7,
    },
    header: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1),
        width: '100%',
    },
    content: {
        flex: 1,
        minWidth: 0,
        overflow: 'hidden',
    },
    contentPreview: {
        padding: theme.spacing(0.5),
        backgroundColor: ({ isResolved }) =>
            isResolved ? 'transparent' : theme.palette.common.white,
    },
    contentText: {
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
    },
    cardContent: {
        paddingTop: theme.spacing(1.5),
        '&:last-child': {
            paddingBottom: theme.spacing(1.5),
        },
    },
    disabledActionIcon: {
        height: 24,
        width: 24,
        color: '#D3D2D3',
        '&:hover': {
            cursor: 'not-allowed',
            color: '#D3D2D3',
        },
    },
    actionIconClashCard: {
        height: 24,
        width: 24,
        borderRadius: 2,
        color: '#D3D2D3',
        transition: 'color 0.2s ease-in-out',
        '&.card-highlight-accept-button': {
            cursor: 'pointer',
            color: '#0D7B55',
        },
    },
    resolveClashIcon: {
        height: pxToRem(8),
        width: pxToRem(8),
    },
}))
